import type { IconDefinition } from '../index.tsx';

export const iconWifiOff: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconWifiOff',
  icon: [
    16,
    16,
    [],
    '',
    'M16 16H13L10.3103 12.6897L8 15L5.65685 12.6568L6.82842 11.4853C7.13914 11.1746 7.56057 11 8 11H8.9375L7.35855 9.05668C6.62695 9.18703 5.94688 9.5384 5.41422 10.0711L4.24264 11.2426L2.82843 9.82843L4.00001 8.65685C4.56995 8.08691 5.24898 7.65114 5.98803 7.36989L4.67837 5.75799C3.90945 6.12819 3.20071 6.62772 2.58579 7.24264L1.41421 8.41421L0 7L1.17157 5.82842C1.83348 5.16652 2.58157 4.61063 3.38948 4.17167L0 0H3L16 16Z M13.4142 7.24264C12.5521 6.38051 11.5055 5.74521 10.3673 5.37513L8.44586 3.01028C10.8448 3.12107 13.1228 4.12278 14.8284 5.82842L16 7L14.5858 8.41421L13.4142 7.24264Z',
  ],
};
